import {TradingAlertRuleType} from "../models/rules/TradingAlertRuleType";

export const RuleTypeDisplay = "alertRuleType";

export function ruleTypeDisplay() {
    return (type: TradingAlertRuleType | null) => {
        if (type == null) {
            return null;
        }
        switch (type) {
            case TradingAlertRuleType.ADX:
                return "trading_alerts.ADX";
            case TradingAlertRuleType.PRICE:
                return "common.PRICE";
        }
    };
}
